module.exports = __webpack_public_path__ + "static/media/Shiny Enterprise Dashboard.0f85bfa4.mp4";